import { useEffect } from 'react';
import { AppContextProvider } from './context/AppContext';
import { resetPadding } from './lib/resetPadding';

import { createRouter, RouterProvider } from '@tanstack/react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useNavigationData } from './hooks/useNavigationData';

const queryClient = new QueryClient();

interface AppProps {
	pageId: string;
	language: string;
}

const KnowledgeCenterRouter = () => {
	const { routeTree } = useNavigationData();

	if (!routeTree) {
		return null;
	}

	const router = createRouter({ routeTree, defaultPreload: 'render' });

	if (!router) {
		return null;
	}

	return <RouterProvider router={router} />;
};

export const KnowledgeCenterApp = ({ pageId, language }: AppProps) => {
	useEffect(() => {
		window.addEventListener('load', () => {
			resetPadding();
		});

		window.addEventListener('resize', () => {
			resetPadding();
		});

		return () => {
			window.removeEventListener('load', () => {
				resetPadding();
			});

			window.removeEventListener('resize', () => {
				resetPadding();
			});
		};
	}, []);

	return (
		<AppContextProvider language={language} pageId={pageId}>
			<QueryClientProvider client={queryClient}>
				<KnowledgeCenterRouter />
			</QueryClientProvider>
		</AppContextProvider>
	);
};
